import type { ExportColumn } from '@app/src/types/export'
import { getProviderExportColumns } from '@app/src/export-columns/provider'
import { SolutionType } from '@app/src/types/resourceExplorer'

export const getProductExportColumns = (basePath?: string, includeOrganizationId?: boolean): ExportColumn[] =>
  [
    {
      translationId: basePath ? 'schemas.mappingNode.productId' : 'schemas.product.worldfavorId',
      exportPath: basePath ? `${basePath}.id` : 'id',
    },
    {
      translationId: basePath ? 'export.schemas.product.name' : 'schemas.product.name',
      exportPath: basePath ? `${basePath}.name` : 'name',
    },
    {
      translationId: basePath ? 'export.schemas.product.gtin' : 'schemas.product.gtin',
      exportPath: basePath ? `${basePath}.gtin` : 'gtin',
    },
    {
      translationId: basePath ? 'export.schemas.product.productNumber' : 'schemas.product.productNumber',
      exportPath: basePath ? `${basePath}.productNumber` : 'productNumber',
    },
    {
      translationId: basePath ? 'export.schemas.product.productCustomId' : 'schemas.product.productCustomId',
      exportPath: basePath ? `${basePath}.productCustomId` : 'productCustomId',
    },
    {
      translationId: basePath ? 'export.schemas.product.purchaseOrder' : 'schemas.product.purchaseOrder',
      exportPath: basePath ? `${basePath}.purchaseOrder` : 'purchaseOrder',
    },
    {
      translationId: basePath ? 'export.schemas.product.countryOfOrigin' : 'schemas.product.countryOfOrigin',
      exportPath: basePath ? `${basePath}.country.name` : 'country.name',
    },
    {
      translationId: basePath ? 'export.schemas.product.countryCode' : 'schemas.product.countryCode',
      exportPath: basePath ? `${basePath}.country.countryCode` : 'country.countryCode',
    },
    {
      translationId: basePath ? 'export.schemas.product.productStatus' : 'schemas.product.productStatus',
      exportPath: basePath ? `${basePath}.productStatus` : 'productStatus',
    },
    {
      translationId: basePath ? 'export.schemas.product.mappingStatus' : 'schemas.product.mappingStatus',
      exportPath: basePath ? `${basePath}.mappingStatus` : 'mappingStatus',
    },
    !basePath && {
      translationId: 'schemas.product.createdAt',
      exportPath: 'createdAt',
    },
    !basePath && {
      translationId: 'schemas.product.updatedAt',
      exportPath: 'updatedAt',
    },
    ...(!basePath ? getProviderExportColumns(SolutionType.Sourcing, 'provider', undefined, includeOrganizationId) : []),
  ].filter(Boolean) as ExportColumn[]
